import { EntityStaff } from "../../entity/EntityStaff";

export class DtoStaffsDeleteRes extends EntityStaff {
  public message: string | null = null;
}
